var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('section',{staticClass:"market-value"},[_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Market Value")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("close")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }